import { render } from "./TheButton.vue?vue&type=template&id=6e041290"
import script from "./TheButton.vue?vue&type=script&lang=js"
export * from "./TheButton.vue?vue&type=script&lang=js"

import "./TheButton.vue?vue&type=style&index=0&id=6e041290&lang=css"

import exportComponent from "F:\\Softwaresul\\Projetos\\LWP\\Nil Recruiter\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__